/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-09-05 13:09:04
 * @LastEditTime : 2024-09-06 09:12:29
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\adjustQuantity.js
 */
import request from "@/utils/request";
export const queryPage = "/icps/system/sign/intelligent/adjustQuantity/queryPage";
//获取工程列表
export function queryEngineerings(params) {
  return request({
    url: "icps/system/sign/intelligent/adjustQuantity/queryEngineerings",
    method: "get",
    params,
  });
}
//查询可选择产品列表
export function queryTableProduct(data) {
  return request({
    url: "icps/system/sign/intelligent/adjustQuantity/queryTableProduct",
    method: "post",
    data,
  });
}
//修改获取已选择产品列表
export function queryProduct(data) {
  return request({
    url: "icps/system/sign/intelligent/adjustQuantity/queryProduct",
    method: "post",
    data,
  });
}
//添加
export function saveData(data) {
  return request({
    url: "icps/system/sign/intelligent/adjustQuantity/saveData",
    method: "post",
    data,
  });
}
//修改
export function updateData(data) {
  return request({
    url: "icps/system/sign/intelligent/adjustQuantity/updateData",
    method: "post",
    data,
  });
}
//附件删除
export function deleteEnclosure(data) {
  return request({
    url: "icps/system/sign/intelligent/adjustQuantity/deleteEnclosure",
    method: "post",
    data,
  });
}
//附件上传
export function uploadEnclosure(data) {
  return request({
    url: "icps/system/sign/intelligent/adjustQuantity/uploadEnclosure",
    method: "post",
    data,
  });
}
//附件上传
export function updateStatus(data) {
  return request({
    url: "icps/system/sign/intelligent/adjustQuantity/updateStatus",
    method: "post",
    data,
  });
}
